require('./mortgageRequestAppraisalRequestPaymentView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const Immutable = require('immutable');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const MortgageRequestAppraisalRequestCostWafer = require('components/mortgageRequest/mortgageRequestAppraisalRequest/mortgageRequestAppraisalRequestCostWafer/mortgageRequestAppraisalRequestCostWafer');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestFormattedRegistryData = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedRegistryData/mortgageRequestFormattedRegistryData');
const MortgageRequestFormattedAddress = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');
const MortgageRequestAnnexConstructions = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesData/mortgageRequestAnnexConstructions/mortgageRequestAnnexConstructions');
const MortgageRequestManageAppraiserVisit = require('components/mortgageRequest/mortgageRequestAppraisalRequest/mortgageRequestManageAppraiserVisit/mortgageRequestManageAppraiserVisit');

// @ constants
const { ESTATES_TYPE_ABBREVIATION, ESTATE_REGISRATION_TYPE } = require('constants/mortgageRequestEstates');
const { PLURAL_CHARACTER } = require('constants/index');

// @ actions
const estatesAction = require('actions/mortgageRequest/mortgageRequestInmuebles');
const paymentAction = require('actions/mortgageRequest/mortgageRequestPayment');

class MortageRequestAppraisalRequestPaymentView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const { requestEstates, requestPayment } = this.props;
        requestEstates(true);
        requestPayment();
    }

    buildAddressContent(immEstate) {
        return (
            <OKInformativeListItem
                title="mortgageRequestAppraisalRequest-step1LivingPlace"
                compact={true}
            >
                <MortgageRequestFormattedAddress
                    immEstate={immEstate}
                    className="mortgage-request-appraisal-request-step-one__text"
                />
            </OKInformativeListItem>
        );
    }
    buildStorageRoomsContent(storageRooms) {
        let storageRoomsContent = '';

        if (storageRooms > 0) {
            const pluralPostfix = storageRooms !== 1 ? PLURAL_CHARACTER : '';
            storageRoomsContent = formatText('mortgageRequestAppraisalRequest-step1StorageRoom', [storageRooms, pluralPostfix]);
        }

        return storageRoomsContent;
    }
    buildAnotherContructionsLabel(immLivingPlace, immAnnexConstructions) {
        let labelContent;

        if (immLivingPlace && immAnnexConstructions.size > 0) {
            labelContent = (
                <FormattedText
                    value="mortgageRequestAppraisalRequest-step1AnotherContructions"
                    className="mortgage-request-appraisal-request-step-one__label"
                />
            );
        }

        return labelContent;
    }

    handleOnCancelAddSimpleNote(evt) {
        evt.preventDefault();

        this.props.history.push('/myprofile/mortgage/panel');
    }
    buildGaragesContent(garages) {
        let garagesContent = '';

        if (garages > 0) {
            const pluralPostfix = garages !== 1 ? PLURAL_CHARACTER : '';
            garagesContent = formatText('mortgageRequestAppraisalRequest-step1Garages', [garages, pluralPostfix]);
        }

        return garagesContent;
    }

    getMappingBreacrumb() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestAppraisalRequest-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }

    buildInlcudeContent(immLivingPlace) {
        const storageRooms = parseInt(immLivingPlace.get('storageRooms'), 0);
        const garages = parseInt(immLivingPlace.get('garages'), 0);

        let includeContent;

        if (storageRooms > 0 || garages > 0) {
            const storageRoomsContent = this.buildStorageRoomsContent(storageRooms);
            const garagesContent = this.buildGaragesContent(garages);

            let title;
            let includeConnector = '';

            if (storageRooms > 0 && garages > 0) {
                includeConnector = formatText('mortgageRequestAppraisalRequest-step1IncludeConnector');
            }

            title = formatText('mortgageRequestAppraisalRequest-step1Include', [storageRoomsContent, includeConnector, garagesContent]);

            includeContent = (
                <OKInformativeListItem title={title} />
            );
        }

        return includeContent;
    }
    buildRegistryDataContent(immEstate) {
        let registryDataContent;
        const idType = immEstate.get('idType');
        const isRegData = idType === ESTATE_REGISRATION_TYPE.REG || idType === ESTATE_REGISRATION_TYPE.REG_DATA;

        if (!immEstate.get('udifir') && isRegData) {
            registryDataContent = (
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-step1RegistryData"
                    compact={true}
                >
                    <MortgageRequestFormattedRegistryData
                        immEstate={immEstate}
                        className="mortgage-request-appraisal-request-step-one__text"
                    />
                </OKInformativeListItem>
            );
        }

        return registryDataContent;
    }

    handleContinueButton() {
        this.props.history.push('/myprofile/mortgage/appraisal-payment');
    }

    buildIdufirContent(immEstate) {
        let udifirContent;
        const idufir = immEstate.get('idufir');

        if (!!idufir) {
            udifirContent = (
                <OKInformativeListItem
                    title="mortgageRequestAppraisalRequest-step1Code"
                    compact={true}
                >
                    <span className="mortgage-request-appraisal-request-step-one__text">{idufir}</span>
                </OKInformativeListItem>
            );
        }

        return udifirContent;
    }
    buildLivingPlaceContent(immLivingPlace) {
        let livingPlaceContent;

        if (immLivingPlace) {
            const addressContent = this.buildAddressContent(immLivingPlace);
            const idufirContent = this.buildIdufirContent(immLivingPlace);
            const registryDataContent = this.buildRegistryDataContent(immLivingPlace);
            const inlcludeContent = this.buildInlcudeContent(immLivingPlace);

            livingPlaceContent = (
                <OKInformativeList>
                    {addressContent}
                    {idufirContent}
                    {registryDataContent}
                    {inlcludeContent}
                </OKInformativeList>
            );
        }

        return livingPlaceContent;
    }
    render() {
        const {
            immEstates,
            immPayment,
            immGlobalPosition
        } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const immLivingPlace = immEstates.get('list').find(immEstate =>
            immEstate.get('propertyType') === ESTATES_TYPE_ABBREVIATION.VIVIENDA
        );
        const livingPlaceContent = this.buildLivingPlaceContent(immLivingPlace);
        const title = formatText('mortgageRequestAppraisalRequest-step1Title');
        const subtitle = formatText('mortgageRequestAppraisalRequest-step1Subtitle');
        const immAnnexConstructions = Immutable.fromJS(immEstates.get('list').reduce((annexContructions, immEstate) => {
            if (immEstate.get('propertyType') !== ESTATES_TYPE_ABBREVIATION.VIVIENDA) {
                annexContructions.push(immEstate);
            }

            return annexContructions;
        }, []));
        const anotherConstructionsLabel = this.buildAnotherContructionsLabel(immLivingPlace, immAnnexConstructions);


        return (
            <div className="mortgage-request-appraisal-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getMappingBreacrumb()}
                                finalTitle={getFinalTitle('mortgageRequestAppraisalRequest-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-2 col-xs-8">
                                <ContentBox>
                                    <div>
                                        <OKBoxTitle
                                            value={title}
                                            size="medium"
                                        />
                                        <div className="mortgage-request-appraisal-view__body-block-2">
                                            {subtitle}
                                        </div>
                                        <div>
                                            {livingPlaceContent}
                                            {anotherConstructionsLabel}
                                            <MortgageRequestAnnexConstructions
                                                immAnnexConstructions={immAnnexConstructions}
                                            />
                                        </div>
                                        <MortgageRequestAppraisalRequestCostWafer
                                            isClientWithoutAccounts={isClientWithoutAccounts}
                                            immPayment={immPayment}
                                        />
                                        <MortgageRequestManageAppraiserVisit isClientWithoutAccounts={isClientWithoutAccounts} />
                                    </div>
                                    <div className="mortgage-request-appraisal-view__disclaimer-important">
                                        <OKMessage type="important">
                                            <FormattedText value={'mortgageRequestAppraisalRequestPaymentView-mortgageRequestAppraisalRequestPaymentView_disclaimerImportant'} />
                                        </OKMessage>
                                    </div>
                                    <div className="mortgage-request-appraisal-view__disclaimer-important">
                                        <OKMessage type="informative">
                                            <FormattedText value={'mortgageRequestAppraisalRequestPaymentView-mortgageRequestAppraisalRequestPaymentView_informativePayment'} />
                                        </OKMessage>
                                    </div>
                                    <hr />
                                    <div className="mortgage-request-simple-note-payment-view__footer">
                                        <a href="#" className="ok-link" onClick={(e) => this.handleOnCancelAddSimpleNote(e)}>
                                            {formatText('common-cancel')}
                                        </a>
                                        <OKButton
                                            onClick={() => this.handleContinueButton()}
                                            modifier="primary"
                                        >
                                            {formatText('mortgageRequestTVPPayment-paymentButton')}
                                        </OKButton>
                                    </div>
                                </ContentBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = MortageRequestAppraisalRequestPaymentView;

MortageRequestAppraisalRequestPaymentView.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object.isRequired,
    mortgageRequestEstates: PropTypes.object,
    requestEstates: PropTypes.func.isRequired,
    requestPayment: PropTypes.func.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
};

module.exports.MortageRequestAppraisalRequestPaymentView = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        immEstates: state.mortgageRequestInmuebles,
        immPayment: state.mortgageRequestPayment,
        immGlobalPosition: state.globalPosition,
    }), {
        requestEstates: estatesAction.requestInmuebles,
        requestPayment: paymentAction.requestPayment,
    }
)(withRouter(MortageRequestAppraisalRequestPaymentView));
